import { LIST_TYPES } from "../../constants/interviewCreditConstants";
import { getLongFormatDate } from "../dateUtils";

export const formatListOfInterviews = (interviews, type) => {
  switch (type) {
    case LIST_TYPES.RAW:
      return interviews;
    case LIST_TYPES.MONTHLY:
      return interviews;
    case LIST_TYPES.DAILY:
      return interviews;
    default:
      return interviews;
  }
};

export const getPageKeyAndNumber = (type) =>
  "interviewCredits" + (type || "raw");

export const getUrlFromInterviewCreditFilters = (filters) => {
  const { from, to } = filters;
  return (from ? `&from=${from}` : "") + (to ? `&to=${to}` : "");
};

export const getInterviewColoumnFromType = (type) => {
  switch (type) {
    case LIST_TYPES.MONTHLY:
      return [
        { key: "month", id: "month", header: "Month" , sortable: true, },
        {
          key: "count",
          id: "count",
          header: "Count of Interviews",
          sortable: true,
        },
      ];
    case LIST_TYPES.DAILY:
      return [
        {
          key: "date",
          id: "date",
          header: "Date",
          body: (row) => getLongFormatDate(row.date),
          sortable: true,
        },
        {
          key: "count",
          id: "count",
          header: "Count of Interviews",
          sortable: true,
        },
      ];
    case LIST_TYPES.RAW:
    default:
      return [
        {
          key: "interviewdate",
          id: "interviewdate",
          header: "Date",
          body: (row) => getLongFormatDate(row.interviewdate),
          sortable: true,
        },
        {
          key: "job",
          id: "job",
          header: "Job",
          sortable: true,
        },
        {
          key: "name",
          id: "name",
          header: "Candidate Name",
        },
      ];
  }
};
